import React from "react";
import Spinner from "./Spinner";

export default function FullScreenLoader({ text = "Lade..." }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-secondary-950 text-gray-300">
      <img
        src="/logo192.png"
        alt="Kirtagames Logo"
        className="w-16 h-16 mb-4 animate-pulse"
      />
      <Spinner size={6} />
      <p className="mt-3 text-sm text-gray-400">{text}</p>
    </div>
  );
}
